import React from 'react';
import { TextField, Typography, Paper } from '@mui/material';

const ObservationsCard = ({ observations, onFieldChange }) => {
  return (
    <Paper elevation={2} sx={{ p: 3 }}>
      <Typography
        variant='h6'
        sx={{ mb: 2, color: '#9291f0', fontWeight: 600 }}
      >
        Observations
      </Typography>
      <TextField
        fullWidth
        multiline
        rows={6}
        label='Observations'
        placeholder='Enter your observations here...'
        value={observations || ''}
        onChange={(e) => onFieldChange('observations', e.target.value)}
        variant='outlined'
      />
    </Paper>
  );
};

export default ObservationsCard;
